module.exports = __webpack_public_path__ + "img/Trap_1142x848.4b560344.png";